import React, {Component} from "react";
import axios from "axios";
import OdooService from "../services/odoo.service";
import ParamsService from "../services/params.service";
import Progressbar from "../common/progress_bar";
import typeCb from "../img/type_cb.jpg";
import jwtDecode from "jwt-decode";
import moment from 'moment';
import {format} from "date-fns";
const  tokenLink = ParamsService.$_GET("token");
const API_URL = process.env.REACT_APP_URL_API;
const USER_NAME_DEFAULT = process.env.REACT_APP_USER_NAME_DEFAULT;
const USER_PWD_DEFAULT = process.env.REACT_APP_USER_PWD_DEFAULT;
const dateCurrent = new Date();
const tokentime = format(new Date(), "dd/MM/yyyy hh:mm:ss");
//Partie config mulesoft
const API_URL_MULE = process.env.REACT_APP_URL_API_MULE;
const AUTHORIZATION_USERNAME = process.env.REACT_APP_URL_API_MULE_USERNAME;
const AUTHORIZATION_PASSWORD = process.env.REACT_APP_URL_API_MULE_PASSWORD;
const authToken = btoa(`${AUTHORIZATION_USERNAME}:${AUTHORIZATION_PASSWORD}`);

export default class Customer extends Component {
    constructor(props) {
        super(props);
        this.disableBack = this.disableBack.bind(this);
        this.reloadPage = this.reloadPage.bind(this);
        this.state = {
            dataPayment: "",
            totalDebts: false,
            dunningActif: false,
            disableAt:"",
            loading:true,
            status:false,
            etape:0,
            error:false,
            pp1:false,
            anticip:false
        }
    }

    loginDefault(tokenlink) {
        var path="login_check";
        var uri = API_URL;
        if(process.env.REACT_APP_MULE==="1") {
            axios.defaults.headers.common['Authorization'] = `Basic ${authToken}`;
            path = "login";
            uri = API_URL_MULE;
        }
        return axios
            .post(uri + path, {
                "username": USER_NAME_DEFAULT,
                "password": USER_PWD_DEFAULT
            }, {mode: 'cors', credentials: 'include'})
            .then(response => {
                if (response.data.token) {
                    this.setState({etape:this.state.etape+20});
                    const token = response.data.token;
                    let user = [];
                    user = jwtDecode(token);
                    user['useremail'] = response.data.email;
                    user['userid'] =  response.data.user_id;
                    user['role'] = response.data.roles;
                    localStorage.setItem("user", JSON.stringify(user));
                    localStorage.setItem("token", token);
                    if(token) {
                        this.getIframeWorldline(token);
                        this.getPaymentCustomer(tokenlink, token);
                    }
                }
            },error => {
                this.setState({error:true});
            });
    }

    getIframeWorldline(token){
        return axios.get(
            API_URL + 'worldline/iframe',
            {
                headers: {
                    Authorization: 'Bearer ' + token
                }
            }).then(
            response => {
                localStorage.setItem("hostedTokenizationUrl", response.data.hostedTokenizationUrl);
                localStorage.setItem("API_URL", API_URL);
                this.setState({etape:this.state.etape+10});

            },
            error => {
                this.setState({error:true});
            }
        );
    }
    getPaymentCustomer(tokenlink, token) {
        return axios.get(
            API_URL + 'customer_payments?token=' + tokenlink,
            {
                headers: {
                    Authorization: 'Bearer ' + token
                }
            })
            .then(response => {
                    let res = response.data['hydra:member'][0];
                    if (res && res.status) {
                        this.setState({totalDebts: res.totalDebts, disableAt: moment(res.disableAt, 'DD/MM/YYYY HH:mm:ss').toDate(), status: res.status});
                        localStorage.setItem("firstDate", res.firstDate);
                        localStorage.setItem("partialAmount", res.amount);
                        localStorage.setItem("processId", res.process.id);
                        localStorage.setItem("listRefInvoiceAnticip", res.process.extraInfo!=="" ? JSON.parse(res.process.extraInfo).listInvoiceAnticipated : false);
                        localStorage.setItem("origine", res.origine);
                        localStorage.setItem("methodPaiment", res.methodPaiment);
                        localStorage.setItem("methodPaymentSpread", res.methodePaymentSpread);
                        localStorage.setItem("nbrEtalement", res.nbreEtalement);
                        localStorage.setItem("pp1", res.pp1);
                        this.setState({dataPayment: res});
                        this.setState({etape:this.state.etape+10});
                        this.setState({pp1: res.pp1===1 ? true : false});
                        this.setState({anticip: (res.process.name==="Etalement anticipé" ? true : false)});
                        OdooService.getContractCustomer(res.customer.customerRef, res.contract.contractRef, token).then(
                            response => {
                                if(res.process.name==="Etalement anticipé"){
                                    response.contracts[0].dunning.invoice_list = response.contracts[0].anticipated.invoice;
                                    response.contracts[0].dunning.payment_list = [];
                                    response.contracts[0].dunning.spread = response.contracts[0].anticipated.infospread.spread;
                                    response.contracts[0].dunning.spread_force_list_amount = response.contracts[0].anticipated.infospread.spread_force_list_amount;
                                    response.contracts[0].dunning.spread_force_list_nbetal = response.contracts[0].anticipated.infospread.spread_force_list_nbetal;
                                    response.contracts[0].dunning.spread_force = response.contracts[0].anticipated.infospread.spread_force;
                                    response.contracts[0].dunning.p0calc = response.contracts[0].anticipated.infospread.p0calc;
                                }
                                localStorage.setItem("contract", JSON.stringify(response.contracts[0]));
                                localStorage.setItem("customer", JSON.stringify(response.customer));
                                this.setState({dunningActif: response.contracts[0].dunning.actif});
                                this.setState({loading: false});
                                this.setState({etape:this.state.etape+60});
                            },
                            error => {
                                this.setState({dunningActif: false});
                                this.setState({totalDebts: false});
                                this.setState({error:true});
                            }
                        );
                    } else {
                        this.setState({loading: false, status: res.status});
                    }


                },
                error => {
                    this.setState({dataPayment: false});
                    this.setState({error:true});

                }
            );


    }

    disableBack() {
        window.history.pushState(null, null, window.location.href);
        window.addEventListener('popstate', function (event) {
            window.history.pushState(null, null, window.location.href);
        });
    }

    componentDidMount() {
        localStorage.removeItem("user");
        localStorage.removeItem("contracts");
        localStorage.removeItem("contract");
        localStorage.removeItem("customer");
        localStorage.removeItem("firstDate");
        localStorage.removeItem("partialAmount");
        localStorage.removeItem("processId");
        localStorage.removeItem("origine");
        localStorage.removeItem("methodPaiment");
        localStorage.removeItem("methodPaymentSpread");
        localStorage.removeItem("nbrEtalement");
        localStorage.setItem("tokentime", tokentime);

        if(tokenLink){
            this.loginDefault(tokenLink);
        }

        this.interval = setInterval(() => {
                this.reloadPage();

        }, 1000); // Exécute la fonction toutes les secondes (1000ms)


    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    reloadPage() {
        if(tokentime !== localStorage.getItem("tokentime")) {
            // Mettez le code de votre fonction ici
            window.location.reload();
            //alert("recharger ta page svp");
        }
    }

    render() {

        return ( <div className="col-md-12">

                { (this.state.loading && !this.state.error) &&
                    <header className="jumbotron">
                        <Progressbar bgcolor="#30ad71" progress={this.state.etape}  height={30} />
                    </header>
                }

                {
                    (!this.state.loading && !this.state.error && ((this.state.totalDebts !== this.state.dunningActif && this.state.pp1===false && this.state.anticip===false)||(this.state.disableAt<dateCurrent && this.state.disableAt!=="") || (this.state.status===false))) && (
                        <header className="jumbotron">
                            <h3>Le lien est expiré ou non valide, merci de nous contacter pour avoir un nouveau lien. </h3>
                        </header>
                    )

                }

                {
                    (this.state.error) && (
                        <header className="jumbotron">
                            <h3>Un problème technique est survenu, prière de rafraichir la page dans quelques minutes.</h3>
                        </header>
                    )
                }


                {(!this.state.loading && this.state.dataPayment && !this.state.error && this.state.dataPayment.customer && this.state.status && ((this.state.totalDebts===this.state.dunningActif && this.state.dunningActif!==false) || this.state.pp1===true || this.state.anticip===true) && this.state.disableAt>dateCurrent && this.state.disableAt!=="") && (
                    <>
                        <header className="jumbotron-customer">
                            <div className="circle-container circle-customer">
                                <div className="circle-text">
                            <span>
                                {this.state.dataPayment.customer.firstname[0] + this.state.dataPayment.customer.lastname[0]}
                            </span>
                                </div>
                            </div>
                            <div>
                        <span className="name">
                            { this.state.dataPayment.customer.firstname + " " + this.state.dataPayment.customer.lastname }
                        </span>
                            </div>
                            <div className="trait"></div>
                            <span className="cm">
                        {this.state.dataPayment.customer.customerRef}
                    </span>
                        </header>

                        <div className="App">
                            <div  className=" row app-step">
                                <div className="step-1 col-3 step">
                                    <span className="circle-customer-step">1</span>
                                    <span className="label-step">Contrat concerné</span>

                                </div>

                                <div className="col-2 trait-payment"></div>

                                <div className="step-2 col-2 step step-current">
                                    <span className="circle-customer-step">2</span>
                                    <span className="label-step">Paiement</span>
                                </div>

                                <div className="col-2 trait-payment"></div>

                                <div className="step-3 col-3 step">
                                    <span className="circle-customer-step">3</span>
                                    <span className="label-step">Validation</span>
                                </div>
                            </div>
                            <div className="col-12 row app-customer">
                                <div className="col-lg-5 col-md-12 col-sm-12 app-customer-left bg-white rounded p-10 mt-5">
                                    <div className="info-p-customer">
                                        <div className="info-customer-p info-title-customer">
                                            <span><b>Récapitulatif du paiement :</b></span>
                                        </div>
                                        <div className="info-customer-p info-contract-customer">
                                            <div className="col-6 info-contract-customer-label">
                                                <span>{this.state.dataPayment.contract.energyType==="EL" ? "ÉLECTRICITÉ" : "GAZ"} contrat n° :</span>
                                            </div>
                                            <div className="col-6 info-contract-customer-ref">
                                                <span>{this.state.dataPayment.contract.contractRef}</span>
                                            </div>
                                        </div>
                                        <div className="info-customer-p info-amount-customer">
                                            <div className="col-6 info-amount-customer-label">
                                                <span><b>Total :</b></span>
                                            </div>
                                            <div className="col-6 info-amount-customer-amount">
                                                <span><b>{this.state.dataPayment.amount} &euro;</b></span>
                                            </div>

                                        </div>
                                    </div>
                                    <div className="col-12 footer-p-customer">
                                        <div>
                                            <img alt="CB" src={typeCb} className="type-cb"/>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-7 col-md-12 col-sm-12 app-customer-right bg-white rounded p-10 mt-5">
                                    <div className="info-customer-p info-title-customer">
                                        <span><b>Paiement par CB :</b></span>
                                    </div>
                                    <iframe id="iframeWorldline" className="iframe_customer"  onLoad={this.disableBack} title={"Iframe Worldline"} src="../../iframeFile/iframe_customer.html" ></iframe>
                                    <div className="text-cb">
                                        <span>
                                            - Les données de carte bancaire seront conservées en toute sécurité par notre prestataire
                                            de services de paiement Worldline pour les futurs paiements qui seront dus au titre du contrat.
                                            Si vous souhaitez que ces données ne soient pas conservées,
                                            vous pourrez nous contacter à tout moment par mail ou téléphone suivant les coordonnées indiquées
                                            dans votre contrat.
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}

            </div>

        );
    }

}
